import { t } from "@/i18n-js/instance";
import {
  isTrialThenUpfrontThenValue,
  isTrialThenValue,
} from "@/react/helpers/paywallPriceHelpers";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface NextPaymentLineProps {
  className?: string;
}

export const NextPaymentLine = ({ className }: NextPaymentLineProps) => {
  const { previewMutation } = usePaywallCheckoutContext();
  const preview = previewMutation.data;

  if (!preview || previewMutation.isLoading) {
    return <SkeletonLoader variant="row" lg className={className} />;
  }

  const nextPaymentLineString = [];

  const hasTax =
    (preview?.first_payment?.tax || 0) > 0 ||
    (preview?.future_payments?.tax || 0) > 0;

  if (hasTax) {
    nextPaymentLineString.push(t("tax_included"));
  }

  if (
    isTrialThenValue(preview.preview_scenario) ||
    isTrialThenUpfrontThenValue(preview.preview_scenario)
  ) {
    nextPaymentLineString.push(
      t("next_payment", {
        next_payment_date: preview.first_payment.formatted_due_on,
      }),
    );
  } else {
    if (preview.future_payments) {
      nextPaymentLineString.push(
        t("next_payment", {
          next_payment_date: preview.future_payments.formatted_start_on,
        }),
      );
    }
  }

  return (
    <div className={classNames("h-full w-full", className)}>
      <Typography.BodyXs color="text-default">
        {nextPaymentLineString.join(" ")}
      </Typography.BodyXs>
    </div>
  );
};
